import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { get, isEmpty } from 'lodash';
import {
  newCheckInAction,
  newNextAction,
  newManualPaymentAction,
  NEW_CHECKIN,
  NEW_NEXT,
  NEW_MANUAL_PAYMENT,
} from '../../actions/navigation';

import Modal from '../../components/Modal';
import Button from '../../components/Button';
import Progress from '../../components/Progress';
import FormRow from '../../components/Form/FormRow';
import FormColumn from '../../components/Form/FormColumn';

import { useConfig } from '../../config/ConfigContext';
import { parseUrlParams, addLusaHeaderParam } from '../../utils/parseUrlParams';

const Check = (props) => {
  const config = useConfig();
  const [isProgressVisible, setIsProgressVisible] = useState(false);
  const [uploadingPercentage, setUploadingPercentage] = useState(0);
  const { fetch: { isDone, isRunning }, navigate, checkinData } = props;
  const match = useParams();
  const workflowType = get(match, 'workflowType') === 'luwa' ? 'dtm-luwa' : get(match, 'workflowType');

  useEffect(() => {
    const params = parseUrlParams(window.location.search);
    if (isEmpty(checkinData)) {
      props.newCheckInAction({
        workflowType,
        key: params.key,
      });
    }
  }, []);

  useEffect(() => {
    if (!get(checkinData, 'data.data.returnUrl', get(checkinData, 'state.data.returnUrl'))
      && ((isDone[NEW_CHECKIN] && !isRunning[NEW_CHECKIN])
      || (isDone[NEW_NEXT] && !isRunning[NEW_NEXT])
      || (isDone[NEW_MANUAL_PAYMENT] && !isRunning[NEW_MANUAL_PAYMENT]))
    ) {
      const params = parseUrlParams(window.location.search);
      let routeUrl = get(checkinData, 'data.url', '').replace(config.hostUrl, '');
      if (routeUrl && params.lusa_header && params.lusa_header === 'false') {
        routeUrl = addLusaHeaderParam(routeUrl);
      }
      navigate(routeUrl);
    }
  }, [checkinData]);

  const handleButtonClick = () => {
    const params = parseUrlParams(window.location.search);

    setIsProgressVisible(true);

    props.newNextAction({
      workflowType,
      key: params.key,
      onUploadProgress: (progressEvent) => {
        setUploadingPercentage(Math.floor((progressEvent.loaded * 100) / progressEvent.total));
      },
    });
  };

  const handleBack = (e) => {
    e.preventDefault();
    const params = parseUrlParams(window.location.search);

    setIsProgressVisible(true);
    props.newManualPaymentAction({
      workflowType,
      key: params.key,
      data: {},
    });
  };

  return (
    <div>
      <Modal className="connect-bank">
        <div className="card-header">
          <button type="button" className="btn-back" onClick={handleBack}>Back</button>
          <h5>Pay By Check</h5>
        </div>
        <div className="card-content">
          <p><strong>Write and mail your check to:</strong></p>
          <p>
            LendingUSA
            <br />
            Attn: Payments Box 206536
            <br />
            Dallas TX, 75320-6536
          </p>
          <FormRow>
            <FormColumn>
              <Button
                onClick={handleButtonClick}
                className="btn arrow"
                title="Confirm Pay By Check"
              />
            </FormColumn>
          </FormRow>
        </div>
      </Modal>
      {
        isProgressVisible && <Progress percent={uploadingPercentage} />
      }
    </div>
  );
};

Check.propTypes = {
  navigate: PropTypes.func.isRequired,
  checkinData: PropTypes.object.isRequired,
  fetch: PropTypes.object.isRequired,
  newCheckInAction: PropTypes.func.isRequired,
  newNextAction: PropTypes.func.isRequired,
  newManualPaymentAction: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  fetch: state.fetch,
  checkinData: state.screen.checkinData,
});

const mapDispatchToProps = {
  newCheckInAction,
  newNextAction,
  newManualPaymentAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(Check);
